<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData" @uploadFile="uploadFile">
      <template v-slot:taskContent="update">
        <!--任务列表-->
        <TASK :update="update"></TASK>
      </template>
    </UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Url from '@/views/crs36/util/url'
  import TASK from '@/views/crs36/active/task.vue'
  import Qs from 'qs'
  const status = {"-1":"待审核",0:"禁用",1:"启用"};
  const androidChannel = {};
  const iosChannel = {};
  const joinCustomerStatus = {0:"未激活",1:"已激活(未完善资料)"};
  const alwaysShow = {0:"否",1:"是"};
  const limitType = {1:"按开户时间限时",2:"按活动时间限时"};
  export default {
    name: 'active',
    components: {
      tablePage,
      FORM,
      UPDATE,
      TASK
    },
    mounted(){
        this.axios.post(Url.active.channel.queryAll).then(res => {
            if (res.code == 0){
                const result = res.result;
                for (let i in result) {
                    if (result[i].os == 'android'){
                        androidChannel[result[i].pkg] = result[i].name;
                    }else if(result[i].os == 'ios'){
                        iosChannel[result[i].pkg] = result[i].name;
                    }
                }
                this.updateData.cols = [
                    { title: 'id', field: 'id',hidden:true},
                    { title: 'activeNo', field: 'activeNo',hidden:true},
                    { title: 'status', field: 'status',hidden:true,data:-1},
                    { title: window.$t('crs36.active.activeName'), field: 'activeName',required:true},
                    { title: window.$t('crs36.active.activeTime'), field: 'activeTime',type:9,required:true,data:[],readonly:(model,col)=>{
                            return (model.id && model.status != -1)?true:false;
                        }},
                    { title: window.$t('crs36.active.bonusDesc'), field: 'bonusDesc'},
                    { title: window.$t('crs36.active.bonusDescVn'), field: 'bonusDescVn'},
                    { title: window.$t('crs36.active.url'), field: 'url'},
                    { title: window.$t('crs36.active.activeDescribe'), field: 'activeDescribe',type:6},
                    { title: window.$t('crs36.active.activeDescribeVn'), field: 'activeDescribeVn',type:6},
                    { title: 'listType(0:黑名单，1：白名单)', field: 'listType',data:0,hidden:true},
                    { title: window.$t('crs36.active.userList'), field: 'userList',type:11,action:Url.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/消息推送用户模板.xlsx"},
                    { title: window.$t('crs36.active.androidChannel'), field: 'androidChannel',type:4,optionList:androidChannel,data:[]},
                    { title: window.$t('crs36.active.iosChannel'), field: 'iosChannel',type:4,optionList:iosChannel,data:[]},
                    { title: window.$t('crs36.active.openTime'), field: 'openTime',type:9,data:[],readonly:(model,col)=>{
                            return (model.id && model.status != -1)?true:false;
                        }},
                    { title: window.$t('crs36.active.joinCustomerStatus'), field: 'joinCustomerStatus',type:4,optionList:joinCustomerStatus,data:[],readonly:(model,col)=>{
                            return (model.id && model.status != -1)?true:false;
                        }},
                    { title: window.$t('crs36.active.alwaysShow'), field: 'alwaysShow',type:3,optionList:alwaysShow,isNumber:true,required:true,data:0},
                    { title: window.$t('crs36.active.limitType'), field: 'limitType',type:3,optionList:limitType,isNumber:true,data:1,required:true,readonly:(model,col)=>{
                            return (model.id && model.status != -1)?true:false;
                        }},
                    { title: window.$t('crs36.active.limitDays'), field: 'limitDays',type:7,required:true,data:1,readonly:(model,col)=>{
                            return (model.id && model.status != -1)?true:false;
                        }},
                    { title: window.$t('crs36.active.taskContent'), field: 'taskContent',type:10,slot:'taskContent',data:[{rewardType:1}]},
                ]
            }
        })
    },
    methods: {
      uploadFile(col,result){
          col.data = (result || []).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          row.activeTime = [row.startTime,row.endTime];
          row.taskContent = JSON.parse(row.taskContent);
          row.androidChannel = row.androidChannel?row.androidChannel.split(","):[];
          row.iosChannel = row.iosChannel?row.iosChannel.split(","):[];
          row.joinCustomerStatus = row.joinCustomerStatus?row.joinCustomerStatus.split(","):[];
          row.openTime = [];
          if (row.openAccountStartTime) row.openTime.push(row.openAccountStartTime);
          if (row.openAccountEndTime) row.openTime.push(row.openAccountEndTime);
          this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
            //审核或启动等操作
            let status = (row.status == -1 || row.status == 0)?1:0;
            this.dataChanage(Url.active.active.editStatus,{id:row.id,status:status},res => {
                this.$refs.childTable.defaultGetData(this.queryData);
                if (res.code == 0){
                    this.$refs.childUpdate.close();
                    this.$message.success("suc");
                }else{
                    this.$message.error(res.message);
                }
            })
        }else if(clickName == "copy"){
          row.id = null;
          row.activeNo = null;
          row.status = -1;
          row.activeTime = [row.startTime,row.endTime];
          row.taskContent = JSON.parse(row.taskContent);
          row.androidChannel = row.androidChannel?row.androidChannel.split(","):[];
          row.iosChannel = row.iosChannel?row.iosChannel.split(","):[];
          row.joinCustomerStatus = row.joinCustomerStatus?row.joinCustomerStatus.split(","):[];
          row.openTime = [];
          if (row.openAccountStartTime) row.openTime.push(row.openAccountStartTime);
          if (row.openAccountEndTime) row.openTime.push(row.openAccountEndTime);
          this.$refs.childUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs36.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if(window.$t('crs36.bt.add') == clickName){
          this.$refs.childUpdate.open();
        }
      },
      alert(title,errorMsg){
          this.$alert(errorMsg || (window.$t('crs36.active.pleaseInput')+title), window.$t('crs36.active.valid'), {
              confirmButtonText: window.$t('crs36.active.enter'),
              callback: action => {
              }
          });
      },
      /*新增数据的校验*/
      vaModel(model){
        model.startTime = model.activeTime[0];
        if(!model.id && model.startTime < new Date().getTime()) {
            this.alert("",window.$t('crs36.active.startTimeError'));
            return false;
        }
        model.endTime = model.activeTime[1];
        model.androidChannel = model.androidChannel.join(",");
        model.iosChannel = model.iosChannel.join(",");
        model.joinCustomerStatus = model.joinCustomerStatus.join(",");
        if (model.openTime.length > 0) {
            model.openAccountStartTime = model.openTime[0];
            model.openAccountEndTime = model.openTime[1];
        }
        if (model.taskContent.length <= 0) {
            this.alert(window.$t('crs36.active.taskContent'));
            return false;
        }
        let taskArr = [];
        for(let i in model.taskContent){
            if(!model.taskContent[i].task || !model.taskContent[i].title ||!model.taskContent[i].describe ||!model.taskContent[i].rewardValue){
                this.alert("",window.$t('crs36.active.taskContentComplete'));
                return false;
            }
            if (taskArr.indexOf(model.taskContent[i].task) >= 0){
                this.alert("",window.$t('crs36.active.taskContentRepeat'));
                return false;
            }
            taskArr.push(model.taskContent[i].task);
        }
        model.taskId = taskArr.join(",");
        model.taskContent = JSON.stringify(model.taskContent);
        return true;
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        console.log(model);
        if(!this.vaModel(model)) return;
        this.dataChanage(model.id?Url.active.active.edit:Url.active.active.save,model,res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{cols:[]},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('crs36.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs36.active.activeName'), field: 'activeName'},
              { title: window.$t('crs36.active.status'), field: 'status',type:2,optionList:status},
              {click: window.$t('crs36.bt.search')},
              {click: window.$t('crs36.bt.add')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.active.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: window.$t('crs36.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs36.active.activeName'), field: 'activeName'},
              { title: window.$t('crs36.common.startTime'), field: 'startTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs36.common.endTime'), field: 'endTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs36.active.status'), field: 'status',render:(data,full)=>{
                  return status[data];
                  }},
              { title: window.$t('crs36.common.createTime'), field: 'createDate'},
              { title: window.$t('crs36.common.updateTime'), field: 'updateDate'},
              { title: window.$t('crs36.active.androidChannel'), field: 'androidChannel'},
              { title: window.$t('crs36.active.iosChannel'), field: 'iosChannel'},
              {title: window.$t('crs36.bt.operation'),width: 300,btnClick:[{name: window.$t('crs36.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},{name:(data,full)=>{
                  if (full.status == -1) return window.$t('crs36.active.review');
                  else if (full.status == 1) return window.$t('crs36.active.disable');
                  else if (full.status == 0) return window.$t('crs36.active.enable');
                      },click:"delete",type:"primary",icon: "el-icon-delete"},
                  {name: window.$t('crs36.active.copy'),click:"copy",type:"primary",icon:"el-icon-edit"}
                ]},

          ]
        }
      }
    }
  }
</script>
